import { themeService } from '../../services/theme/ThemeService';
import { Component } from 'react';
import React from 'react';
import { withThemeLoader } from '../../decorators/withThemeLoader';

export class ImprovementHubLoader {
  
  static Layout = null;
  
  static theme = themeService.THEMES.THEME_IMPROVEMENT_HUB;
  
  static async load(callback) {
    window._ = (await import('lodash')).default;
    
    await import(/* webpackChunkName: "improvement-hub-theme" */ 'improvement-hub/index.less');
    
    if (!ImprovementHubLoader.Layout) {
      const rawLayout = await import(/* webpackChunkName: "improvement-hub-module-layout" */ './layouts/moduleLayout');
      ImprovementHubLoader.Layout = withThemeLoader(rawLayout.default, ImprovementHubLoader.theme);
    }
    callback(null, ImprovementHubLoader.Layout);
  }
  
}
